import { Injectable, NgZone } from '@angular/core';
import { Subject } from 'rxjs';
interface UiMessage<T = any> {
  type: string;
  data: T;
}
@Injectable({
  providedIn: 'root'
})

export class UiMessageService {
  private allowedTypes = new Set(['PLAY_STREAM', 'SHOW_EXTERNAL_WEB_PAGE']);
  private message$ = new Subject<UiMessage>();

  constructor(private zone: NgZone) { }

  init() {
    window.addEventListener('message', (event) => {
      // optional security check
      // if (event.origin !== 'http://localhost:3000') return;
      if (this.allowedTypes.has(event.data['type'])) {
        this.zone.run(() => {
          this.message$.next(event.data);
        });
      }

    });
  }

  onMessage() {
    return this.message$.asObservable();
  }
}

